<template>
  <div>
    <div v-for="(item,index) in historyList" :key="index" class="mt-3  pa-5">
      <v-card class="pa-3">
        <v-card-title>
          {{ item.type }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!--          <v-row no-gutters>-->
          <div class="d-flex overflow-x-auto">
            <div v-for="(item,index) in item.data" :key="index">
              <v-hover v-slot="{ hover }">
                <v-card elevation="5" max-width="150" class="ma-3">
                  <v-img :src="item.img ? item.img : errorImg" :lazy-src="lazyImg"
                         class="align-end" height="200"
                         gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                    <v-card-title>
                      <v-progress-linear height="13" bottom background-color="#607D8B" rounded
                                         :value="percentage(item.duration, item.currentTime)">
                        <strong>{{ percentage(item.duration, item.currentTime) }}%</strong>
                      </v-progress-linear>
                    </v-card-title>
                  </v-img>
                  <div class="py-2 px-1 text-center text-no-wrap text-truncate">
                    {{ item.title }}
                  </div>
                  <v-fade-transition>
                    <v-overlay
                        v-if="hover"
                        absolute
                        z-index="2"
                    >
                      <div class="btn-class">
                        <v-btn fab @click="toPlay(item)">
                          <v-icon>mdi-play</v-icon>
                        </v-btn>
                        <v-btn fab @click="deleteHistory(item)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </v-overlay>
                  </v-fade-transition>
                </v-card>
              </v-hover>
            </div>
          </div>
          <!--          </v-row>-->
        </v-card-text>
      </v-card>
    </div>

    <!-- 右下角控件-->
    <div>
      <v-speed-dial
          class="mb-15"
          value="true"
          bottom
          right
          fixed
          direction="top"
          transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <div>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab v-bind="attrs" v-on="on" @click="_clearHistory">
                  <v-icon color="#cd292a">
                    auto_delete
                  </v-icon>
                </v-btn>
              </template>
              <span>清空历史</span>
            </v-tooltip>
          </div>
        </template>

      </v-speed-dial>

      <!-- 右下角回到顶部-->
      <back-top></back-top>
    </div>

  </div>
</template>

<script>
import {mapMutations, mapGetters} from 'vuex'
import BackTop from "@/components/BackTop";

export default {
  name: "history",
  components: {BackTop},
  data: () => ({
    errorImg: require('@/assets/error-loading.gif'),
    lazyImg: require('@/assets/img-loading.gif'),
    historyList: []
  }),
  mounted() {
    this.initHistory()
  },
  computed: {
    ...mapGetters(['getNode', 'getHistoryList']),
  },
  methods: {
    ...mapMutations(['setHistory', 'delHistory', 'clearHistory']),
    deleteHistory({vid}) {
      let param = {
        vid: vid
      }

      this.delHistory(param)

      this.initHistory()
    },
    _clearHistory() {
      this.clearHistory()

      this.historyList = []

      this.$router.push({
        path: '/video'
      })
    },
    initHistory() {
      let format = this.$options.filters['dateFormat']

      this.getHistoryList.forEach(item => {
        item.date = format(item.time, 'YYYY-mm-dd')
      })

      let _list = this.itemGroupBy(this.getHistoryList, 'date')

      _list.forEach(item => {
        let group = this.itemGroupBy(item.data, 'vid')

        let data = []
        group.forEach(i => {
          data.push(i.data[0])
        })
        this.historyList.push({
          type: item.type,
          data: data
        })
      })
    },
    percentage(duration, currentTime) {
      let p = Math.round((currentTime / duration) * 100);
      return p ? p : 0
    },
    itemGroupBy(arr, key) {
      let newArr = [],
          types = {},
          i, j, cur;
      for (i = 0, j = arr.length; i < j; i++) {
        cur = arr[i];
        if (!(cur[key] in types)) {
          types[cur[key]] = {type: cur[key], data: []};
          newArr.push(types[cur[key]]);
        }
        types[cur[key]].data.push(cur);
      }
      return newArr;
    },
    toPlay(item){
      this.$router.push({
        path: '/video/player',
        query: {eid: item.eid, vid: item.vid}
      })
    }
  },
}


</script>

<style scoped>
.btn-class {
  display: flex;
  flex-direction: column;
}
</style>
